module.exports = __webpack_public_path__ + "img/left-bottom-shape.f9fffdad.svg";